import { render, staticRenderFns } from "./projectTaskHistoryTab.vue?vue&type=template&id=5ed8546c&scoped=true&"
import script from "./projectTaskHistoryTab.vue?vue&type=script&lang=js&"
export * from "./projectTaskHistoryTab.vue?vue&type=script&lang=js&"
import style0 from "./projectTaskHistoryTab.vue?vue&type=style&index=0&id=5ed8546c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed8546c",
  null
  
)

export default component.exports